import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { AlertService } from 'src/app/common/alert.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/shared/common.service';
import { Router } from '@angular/router';
import { Global } from 'src/app/Global';
import saveAs from 'file-saver';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { HTTPStatus } from 'src/app/common/app-token-handler';
import { EmployeeRecoveryService } from 'src/app/shared/employee-recovery.service';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';


@Component({
  selector: 'app-finance-recovery-view',
  templateUrl: './finance-recovery-view.component.html',
  styleUrls: ['./finance-recovery-view.component.css'],
  // standalone: true,
  // imports:[MatPaginatorModule,DropdownModule,FormsModule,MatTableModule,
  //   MatDatepickerModule,ReactiveFormsModule,DatePipe,CommonModule]
  
})
export class FinanceRecoveryViewComponent implements OnInit {
/***********************************Declare Private Properties************************/
EmployeeRecoveryRecordsForm: UntypedFormGroup;
isLoadingResults = false;
PenaltyTypeList:any;
AssestTypeList:any;
FirmList:any;
ReportedLocationList:any;
ITRecoveryStatusList:any;
private alertService: AlertService;
displayedColumns = ['RecordID', 'EmployeeName', 'EmailID','EmployeeLocation','ReportedLocation','AssetType','PenaltyType','PenaltyAmount', 'WaiverID', 'CreatedBy','CreatedDate', 'Status'];

FinanceViewDataSource: MatTableDataSource<any[]>;
@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
@ViewChild(MatSort, { static: true }) sort: MatSort;

/******************************************END***************************************/

constructor(private _fb: UntypedFormBuilder, private _router: Router, public _global: Global,
  public _commonService: CommonService, private error: AppErrorHandler,
  injector: Injector,private status: HTTPStatus,
  private _EmployeeRecovery:EmployeeRecoveryService) {this.alertService = injector.get(AlertService); }

ngOnInit() {

  this.paginator.showFirstLastButtons = true;
  this.paginator.pageSize = this._global.RecordSize;
  this.EmployeeRecoveryRecordsForm = this._fb.group({            
    PenaltyTypeID: [''],
    AssetTypeID: [''],
    ReportedLocationID: [''],
    FromRecoveryDate:[],
    ToRecoveryDate:[],
    CreatedBy:[],
    UserLocation:[],
    UserName:[],
    entityid: [''],
    ITRecoveryStatus:[],    
    PageNumber: (this._global.pageIndex),
    RecoveryID: ['']
    
  });
  this.BindAssetTypeList();
  this.BindPenaltyTypeList();
  this.BindReportedLocationList(); 
  this.BindFirmTypeList(); 
  this.BindITRecoveryStatusList();  
  
}
BindPenaltyTypeList() {
  this._commonService.BindDropDown('Penalty').subscribe(result => {
    this.PenaltyTypeList = result;
  });
}
BindAssetTypeList() {
  this._commonService.BindDropDown('Assest').subscribe(result => {
    this.AssestTypeList = result;
  });
}
BindReportedLocationList() {
  this._commonService.BindDropDown('Location').subscribe(result => {
    this.ReportedLocationList = result;
  });
}
BindFirmTypeList() {
  this._commonService.BindDropDown('Firm').subscribe(result => {    
    this.FirmList = result;
  });
}
BindITRecoveryStatusList() {
  this._commonService.BindDropDown('JVStatus').subscribe(result => {    
    this.ITRecoveryStatusList = result;
  });
}
SearchRecord() { 
  this._global.pageIndex = 1;
  this._global.length = 0;
  this._global.totalPage = 0;
  this.EmployeeRecoveryRecordsFormList();
}

EmployeeRecoveryRecordsFormList() {
  this.status.setHttpStatus(true);
  this.EmployeeRecoveryRecordsForm.controls.PageNumber.setValue(this._global.pageIndex - 1);
  this._EmployeeRecovery.GetAllEmployeeRecoveryFinanceList(this.EmployeeRecoveryRecordsForm.value).subscribe(data => {
    if (data.RequestData != null && data.RequestData.length > 0) {  
      this.FinanceViewDataSource = new MatTableDataSource(data.RequestData);
      if (this._global.length === 0) {
        this._global.length = data.TotalRecordCount;
        this.FinanceViewDataSource.paginator = this.paginator;
        this._global.totalPage = Math.ceil(this._global.length / this.paginator.pageSize);
        this.FinanceViewDataSource.sort = this.sort;
      } else {
        this.paginator.pageIndex = this._global.pageIndex - 1;
        this.status.setHttpStatus(false);
      }
    } else {   
      this.FinanceViewDataSource = new MatTableDataSource(data.RequestData);
      this._global.length = data.TotalRecordCount;
      this.paginator.pageSize = this._global.RecordSize;
      this._global.pageIndex = 1;
      this._global.totalPage = 0;
    }
  }, (error) => {
    this.status.setHttpStatus(false);
    this.error.handleError(error);
  }, () => {  this.status.setHttpStatus(false); });
}

ShowDetails(row: any) {     
  this._router.navigate(['admin/create-recovery', row.RequestEntityId]);
}

Reset() {
  this.EmployeeRecoveryRecordsForm.reset();
  this.SearchRecord();
}

// ******************************************Pagging*************************************//
onPaginateChange(e: any) {
  this._global.pageIndex = (e.pageIndex + 1);
  this.EmployeeRecoveryRecordsFormList();
}


GoToPage() {
  if (this._global.pageIndex <= 0) { this._global.pageIndex = 1; } else if
    (this._global.pageIndex > this._global.totalPage) {
    this._global.pageIndex = this._global.totalPage;
  }
  this.EmployeeRecoveryRecordsFormList();
}

Export() {
 
  this._EmployeeRecovery.RecoveryExportFinanceData(this.EmployeeRecoveryRecordsForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, 'EmployeeRecoveryDetails.xls');
  });
}
orgValueChange(keyName: String) {
if (keyName === 'FromDate') {
  if (this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== '' &&
    this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== null) {
    if (this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.value > this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value) {
      this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.reset();
      this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.reset();
      this.alertService.notify('warn', 'warn!', 'From date cannot be greater than To date.');
    }
  }
}
if (keyName === 'ToDate') {
  if (this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== '' &&
    this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value !== null) {
    if (this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.value < this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.value) {
      this.EmployeeRecoveryRecordsForm.controls.ToRecoveryDate.reset();
      this.EmployeeRecoveryRecordsForm.controls.FromRecoveryDate.reset();
      this.alertService.notify('warn', 'warn!', 'To date can not be smaller then from date.');
    }
  }
}
}
// **************************************Pagging End*************************************//
}
